import React from "react";
import { Checkbox } from "./ui/checkbox";
import { MODULES } from "../lib/perms";

const INVOICE_SCOPES = [
  { value: "none", label: "Fara acces" },
  { value: "own", label: "Doar ale lui" },
  { value: "all", label: "Toate" },
];

export const PermissionsEditor = ({ value, onChange, testPrefix }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="flex flex-wrap gap-x-5 gap-y-3 items-center" data-testid={`${testPrefix}-perms`}>
      {MODULES.filter((m) => m.key !== "invoices").map((m) => (
        <label key={m.key} className="flex items-center gap-2 text-sm cursor-pointer select-none">
          <Checkbox
            checked={Boolean(value[m.key])}
            onCheckedChange={(c) => set(m.key, c === true)}
            data-testid={`${testPrefix}-perm-${m.key}`}
          />
          {m.label}
        </label>
      ))}
      <div className="flex items-center gap-2 text-sm">
        <span>Facturi:</span>
        <select
          value={value.invoices || "none"}
          onChange={(e) => set("invoices", e.target.value)}
          className="h-8 border border-zinc-300 rounded-sm px-2 text-sm bg-white"
          data-testid={`${testPrefix}-perm-invoices`}
        >
          {INVOICE_SCOPES.map((s) => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};
